const Spin = ({ className = "", "data-testid": dataTestId }) => {
  const testId = (suffix) => (dataTestId ? `${dataTestId}-${suffix}` : undefined);
  return (
    <>
      <style>{`
        .antd-spin {
          display: inline-block;
          position: relative;
          width: 14px;
          height: 14px;
        }
        .antd-spin-dot {
          position: relative;
          display: inline-block;
          width: 14px;
          height: 14px;
          transform: rotate(45deg);
          animation: antd-spin-rotate 1.2s infinite linear;
        }
        .antd-spin-dot i {
          position: absolute;
          display: block;
          width: 6px;
          height: 6px;
          background-color: currentColor;
          border-radius: 100%;
          transform: scale(0.75);
          transform-origin: 50% 50%;
          opacity: 0.3;
          animation: antd-spin-move 1s infinite linear alternate;
        }
        .antd-spin-dot i:nth-child(1) {
          top: 0;
          left: 0;
          animation-delay: 0s;
        }
        .antd-spin-dot i:nth-child(2) {
          top: 0;
          right: 0;
          animation-delay: 0.4s;
        }
        .antd-spin-dot i:nth-child(3) {
          right: 0;
          bottom: 0;
          animation-delay: 0.8s;
        }
        .antd-spin-dot i:nth-child(4) {
          bottom: 0;
          left: 0;
          animation-delay: 1.2s;
        }
        @keyframes antd-spin-rotate {
          to {
            transform: rotate(405deg);
          }
        }
        @keyframes antd-spin-move {
          to {
            opacity: 1;
          }
        }
      `}</style>
      <span className={`inline-block ${className}`} data-testid={dataTestId}>
        <span className="antd-spin" data-testid={testId("container")}>
          <span className="antd-spin-dot" data-testid={testId("dot")}>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
          </span>
        </span>
      </span>
    </>
  );
};

export default Spin;

